// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  flex: none;
  line-height: 0;
}

.image-preview-trigger {
  width: 1.75rem;
  height: 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.2);
  border-radius: 0.5rem;
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.1);
  color: var(--ion-color-primary, #3880ff);
  cursor: zoom-in;
  transition: transform 180ms cubic-bezier(0.16, 1, 0.3, 1), background-color 180ms cubic-bezier(0.16, 1, 0.3, 1), border-color 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

.image-preview-trigger:hover {
  border-color: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.38);
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.18);
}

.image-preview-trigger:active {
  transform: scale(0.96);
}

.image-preview-trigger:focus-visible {
  outline: 3px solid rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.35);
  outline-offset: 2px;
}

.image-preview-trigger ion-icon {
  width: 1rem;
  height: 1rem;
}

.image-preview-modal {
  --width: min(92vw, 72rem);
  --height: min(88dvh, 50rem);
  --border-radius: 16px;
  --box-shadow: 0 24px 72px rgba(15, 23, 42, 0.28);
}

.preview-dialog {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color, #1f2937);
}

.preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 0.75rem 0.75rem 1.25rem;
  border-bottom: 1px solid var(--ion-color-light-shade, #d7d8da);
}

.preview-header h2 {
  margin: 0.1rem 0 0;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.preview-eyebrow {
  display: block;
  color: var(--ion-color-medium, #92949c);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.preview-stage {
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1rem, 3vw, 2rem);
  overflow: hidden;
  background: var(--ion-color-light, #f4f5f8);
}

.preview-image-frame {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-image {
  object-fit: contain;
}

@media (max-width: 767px) {
  .image-preview-modal {
    --width: 100%;
    --height: 100%;
    --border-radius: 0;
  }
  .preview-stage {
    padding: 0.75rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .image-preview-trigger {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/image-preview/image-preview.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,UAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,uEAAA;EACA,qBAAA;EACA,iEAAA;EACA,wCAAA;EACA,eAAA;EACA,iKAAA;AACF;;AAIA;EACE,oEAAA;EACA,kEAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,yEAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gDAAA;AADF;;AAIA;EACE,aAAA;EACA,uCAAA;EACA,YAAA;EACA,6CAAA;EACA,qCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,wCAAA;EACA,8DAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADF;;AAIA;EACE,cAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,2CAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE;IACE,aAAA;IACA,cAAA;IACA,kBAAA;EADF;EAIA;IACE,gBAAA;EAFF;AACF;AAKA;EACE;IACE,gBAAA;EAHF;AACF","sourcesContent":[":host {\n  display: inline-flex;\n  flex: none;\n  line-height: 0;\n}\n\n.image-preview-trigger {\n  width: 1.75rem;\n  height: 1.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.2);\n  border-radius: 0.5rem;\n  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.1);\n  color: var(--ion-color-primary, #3880ff);\n  cursor: zoom-in;\n  transition: transform 180ms cubic-bezier(0.16, 1, 0.3, 1),\n  background-color 180ms cubic-bezier(0.16, 1, 0.3, 1),\n  border-color 180ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.image-preview-trigger:hover {\n  border-color: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.38);\n  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.18);\n}\n\n.image-preview-trigger:active {\n  transform: scale(0.96);\n}\n\n.image-preview-trigger:focus-visible {\n  outline: 3px solid rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.35);\n  outline-offset: 2px;\n}\n\n.image-preview-trigger ion-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.image-preview-modal {\n  --width: min(92vw, 72rem);\n  --height: min(88dvh, 50rem);\n  --border-radius: 16px;\n  --box-shadow: 0 24px 72px rgba(15, 23, 42, 0.28);\n}\n\n.preview-dialog {\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #1f2937);\n}\n\n.preview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 0.75rem 0.75rem 1.25rem;\n  border-bottom: 1px solid var(--ion-color-light-shade, #d7d8da);\n}\n\n.preview-header h2 {\n  margin: 0.1rem 0 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\n.preview-eyebrow {\n  display: block;\n  color: var(--ion-color-medium, #92949c);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.preview-stage {\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: clamp(1rem, 3vw, 2rem);\n  overflow: hidden;\n  background: var(--ion-color-light, #f4f5f8);\n}\n\n.preview-image-frame {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.preview-image {\n  object-fit: contain;\n}\n\n@media (max-width: 767px) {\n  .image-preview-modal {\n    --width: 100%;\n    --height: 100%;\n    --border-radius: 0;\n  }\n\n  .preview-stage {\n    padding: 0.75rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .image-preview-trigger {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
